import {
  TextInput, Button, Table, Loader,
} from '@mantine/core';
import { Page } from '@/components';
import { notifications } from '@mantine/notifications';
import { useEffect, useState } from 'react';
import Loading from '@/components/Loading';
import { useTranslation } from 'react-i18next';
import { useGetAllRatesMutation, useUpdateRateMutation } from '@/services/api';
import { getMutationResult } from '@/helpers/query';
import { useForm } from '@mantine/form';
import classes from './style.module.css';

const ReverseRate = () => {
  const { t } = useTranslation();
  const [ratesLoading, setRatesLoading] = useState(false);
  const [saving, setSaving] = useState(false); // מצב שמירה כללי
  const [apiGetAllRates] = useGetAllRatesMutation();
  const [apiUpdateRate] = useUpdateRateMutation();

  const form = useForm({
    initialValues: {
      rates: [],
    },
  });

  const fetchRates = async () => {
    setRatesLoading(true);
    try {
      const { data } = await getMutationResult({}, apiGetAllRates);
      if (data.success) {
        form.setFieldValue('rates', data.data);
      }
    } catch (error) {
      console.error(error);
      notifications.show({
        title: t('globals.errors.loadFailed'),
        message: '',
        color: 'red',
      });
    }
    setRatesLoading(false);
  };

  useEffect(() => {
    fetchRates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSaveAll = async () => {
    setSaving(true);
    try {
      const { data } = await getMutationResult(
        { rates: form.values.rates },
        apiUpdateRate,
      );

      if (data.success) {
        notifications.show({
          title: 'המידע נשמר בהצלחה',
          message: 'המידע נשמר בהצלחה',
        });
      } else {
        notifications.show({
          title: 'המידע לא נשמר בהצלחה',
          message: '',
          color: 'red',
        });
      }
    } catch (error) {
      notifications.show({
        title: 'המידע לא נשמר בהצלחה',
        message: '',
        color: 'red',
      });
    }
    setSaving(false);
  };

  const handlePresentChange = (e, idx) => {
    const newRates = [...form.values.rates];
    newRates[idx] = { ...newRates[idx], present: e.target.value };
    form.setValues({ rates: newRates });
  };

  if (ratesLoading) return <Loading />;

  return (
    <>
      <Page.Head
        title={t('pages.settings.pages.reverseRate.title')}
        subtitle={t('pages.settings.pages.reverseRate.description')}
      />
      <div className={classes.container}>
        <div className={classes.tabContent}>
          <Table>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>{t('pages.settings.pages.reverseRate.table.headers.company')}</Table.Th>
                <Table.Th>{t('pages.settings.pages.reverseRate.table.headers.present')}</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {form.values.rates.length === 0 ? (
                <Table.Tr>
                  <Table.Td colSpan={2} style={{ textAlign: 'center' }}>
                    {t('pages.settings.pages.reverseRate.noData')}
                  </Table.Td>
                </Table.Tr>
              ) : (
                form.values.rates.map((rate, idx) => (
                  <Table.Tr key={rate._id}>
                    <Table.Td>{rate.company}</Table.Td>
                    <Table.Td>
                      <TextInput
                        value={rate.present}
                        onChange={(e) => handlePresentChange(e, idx)}
                        rightSection="%"
                      />
                    </Table.Td>
                  </Table.Tr>
                ))
              )}
            </Table.Tbody>
          </Table>
        </div>
        <div className={classes.buttonsWrapper}>
          <Button
            mt="md"
            onClick={handleSaveAll}
            disabled={saving}
          >
            {saving ? <Loader size="xs" /> : t('globals.save')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default ReverseRate;
